import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import recap1 from './pictures/apcsarecap.jpeg';  

const CSA = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC at Work</b>
              </h3>
            </header>
            <section>
              <h2>WiC AP CSA Workshop Series</h2>
              <p className="site-post-meta">May 9, 2025</p>
              <hr />
            </section>
            <section>
              <p>

              🚀 Huge thanks to everyone who joined the Outreach team’s AP CSA Workshop Series these past two weeks!

              <br></br>
                <br></br>


We had nearly 180 sign-ups from students all over, eager to prep for the AP Computer Science A exam. 📚💻 The sessions walked through key units, tackled FRQs, and shared strategies to master the exam 🎯

<br></br>
<br></br>

We loved seeing so much enthusiasm and determination from high schoolers pursuing CS. You're the future of tech, and we're proud to be part of your journey! 💡🧠

<br></br>
<br></br>       
              </p>
              <img src={recap1} alt="Recap 1" />
              
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CSA;